"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingNotesEmailModalActions = void 0;
var __1 = require("../..");
var button_1 = require("../button/button");
var fields_1 = require("../fields");
var MeetingNotesEmailModalActions;
(function (MeetingNotesEmailModalActions) {
    MeetingNotesEmailModalActions["VisibilityChanged"] = "VisibilityChanged";
    MeetingNotesEmailModalActions["DataLoaded"] = "DataLoaded";
    MeetingNotesEmailModalActions["Sending"] = "Sending";
    MeetingNotesEmailModalActions["Sent"] = "Sent";
})(MeetingNotesEmailModalActions || (exports.MeetingNotesEmailModalActions = MeetingNotesEmailModalActions = {}));
var MeetingNotesReportEmailModal = /** @class */ (function () {
    function MeetingNotesReportEmailModal(api) {
        var _this = this;
        this.api = api;
        this.buildForm = function () {
            _this._subjectField = new fields_1.TextField('subject', 'Subject', true, 500, 'Required');
            _this._emailTemplateField = new fields_1.RichTextField('message', 'Message', true, 'required');
            _this._recipientsField = new fields_1.MultipleEmailField('recipients', true, 'Recipient(s)');
            _this._ccEmailField = new fields_1.MultipleEmailField('CcAddresses', false, 'CC Address(s)');
            _this._form = new __1.Form([
                _this._subjectField,
                _this._emailTemplateField,
                _this._recipientsField,
                _this._ccEmailField
            ], {
                meetingId: _this._meetingId,
                meetingUniqueId: _this._meeingUniqueId,
            });
        };
        this.show = function (meetingId, meetingUniqueId, meetingName, meetingNumber, eventName, eventYear) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._meetingId = meetingId;
                this._meeingUniqueId = meetingUniqueId;
                this._isOpen = true;
                this.observationProvider.notifyObservers(MeetingNotesEmailModalActions.VisibilityChanged);
                this.buildForm();
                this._subjectField.setValue('Meeting Notes: ' + meetingName + ' - ' + eventName + ' (' + eventYear + ')');
                this._emailTemplateField.setValue('' +
                    'A TEMS User has shared meeting notes for the following meeting. Use the URL to access these notes.' +
                    '<br/>' +
                    '<br/>' +
                    'Meeting Name: ' + meetingName +
                    '<br/>' +
                    'Meeting Number: ' + meetingNumber +
                    '<br/>' +
                    'Event: ' + eventName + ' (' + eventYear + ')' +
                    '<br/>' +
                    '<br/>' +
                    '[Url]');
                this.observationProvider.notifyObservers(MeetingNotesEmailModalActions.DataLoaded);
                return [2 /*return*/];
            });
        }); };
        this.hide = function () {
            _this._isOpen = false;
            _this.alert.hide();
            _this.sendButton.setProcessing(false);
            _this.observationProvider.notifyObservers(MeetingNotesEmailModalActions.VisibilityChanged);
        };
        this.send = function () { return __awaiter(_this, void 0, void 0, function () {
            var request, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._form.submit();
                        if (!this._form.isValid()) {
                            this.sendButton.setProcessing(false);
                            return [2 /*return*/];
                        }
                        request = this._form.model;
                        this.observationProvider.notifyObservers(MeetingNotesEmailModalActions.Sending);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.post("".concat(__1.EndpointUrls.Meetings, "/").concat(this._meetingId, "/SendMeetingNotesEmail"), request)];
                    case 2:
                        _a.sent();
                        this.observationProvider.notifyObservers(MeetingNotesEmailModalActions.Sent);
                        this.hide();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.sendButton.setProcessing(false);
                        this.alert.show({
                            alertType: __1.AlertType.Error,
                            heading: 'Unable to send',
                            message: 'An error occurred trying to send the email'
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.observationProvider = new __1.ObservationProvider();
        this._title = "Email Meeting Notes";
        this.closeButton = new button_1.default({
            onClick: this.hide,
            text: 'Close'
        });
        this.sendButton = new button_1.default({
            onClick: this.send,
            text: 'Send',
            processingText: 'Sending...'
        });
        this.alert = new __1.Alert();
    }
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "title", {
        get: function () {
            return this._title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "subjectField", {
        get: function () {
            return this._subjectField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "recipientsField", {
        get: function () {
            return this._recipientsField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "ccEmailField", {
        get: function () {
            return this._ccEmailField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "emailTemplateField", {
        get: function () {
            return this._emailTemplateField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingNotesReportEmailModal.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    return MeetingNotesReportEmailModal;
}());
exports.default = MeetingNotesReportEmailModal;
